export var EditRegionsActions;
(function (EditRegionsActions) {
    EditRegionsActions["Add"] = "add";
    EditRegionsActions["Remove"] = "remove";
    EditRegionsActions["Move"] = "move";
    EditRegionsActions["Resize"] = "resize";
})(EditRegionsActions || (EditRegionsActions = {}));
//# sourceMappingURL=edit-regions.constants.js.map